export type { RelatedProductsSectionProps } from './RelatedProductsSection';
export { default } from './RelatedProductsSection';
